export default "__VITE_ASSET__DFUvGwWP__"